const AssessmentTableColumn = {
  initial_assessment: "Initial Assessment",
  end_of_topic: "End Of Topic",
  program_check: "Progress Check",
  post_assessment: "Post Assessment",
};

export default AssessmentTableColumn;
